export default {
	/* 
		adds intersection observation for the component.$el
		triggers onVisible method when $el comes into the viewport
		triggers onNotVisible method when $el leaves the viewport
	*/
	data() {
		return {
			in_view: false,
			in_view_once: false
		};
	},
	methods: {
		initObserver() {
			const options = {
				threshold: 0.10
			};
			let observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if ( entry.isIntersecting ) {
						this.onVisible();
					} else {
						this.onNotVisible();
					}
				});
			}, options);
			observer.observe(this.$el);
			this.$options.observer = observer;
		},

		onVisible() {
			this.in_view = true;
		},
		onNotVisible() {
			this.in_view = false;
		},
	},

	mounted() {
		this.initObserver();
	},

	destroyed() {
		let observer = this.$options.observer;
		if ( observer ) {
			observer.disconnect();
		}
	},

};